export var BiometricErrorCode;
(function (BiometricErrorCode) {
    BiometricErrorCode["BIOMETRIC_UNAVAILABLE"] = "BIOMETRIC_UNAVAILABLE";
    BiometricErrorCode["AUTHENTICATION_FAILED"] = "AUTHENTICATION_FAILED";
    BiometricErrorCode["USER_CANCELLED"] = "USER_CANCELLED";
    BiometricErrorCode["TIMEOUT"] = "TIMEOUT";
    BiometricErrorCode["LOCKOUT"] = "LOCKOUT";
    BiometricErrorCode["NOT_ENROLLED"] = "NOT_ENROLLED";
    BiometricErrorCode["PLATFORM_NOT_SUPPORTED"] = "PLATFORM_NOT_SUPPORTED";
    BiometricErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
})(BiometricErrorCode || (BiometricErrorCode = {}));
export var BiometryType;
(function (BiometryType) {
    BiometryType["FINGERPRINT"] = "fingerprint";
    BiometryType["FACE_ID"] = "faceId";
    BiometryType["TOUCH_ID"] = "touchId";
    BiometryType["IRIS"] = "iris";
    BiometryType["MULTIPLE"] = "multiple";
    BiometryType["UNKNOWN"] = "unknown";
})(BiometryType || (BiometryType = {}));
//# sourceMappingURL=types.js.map